import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import { Provider } from "react-redux";
import store from "./store/store";
import { App } from "./App";
if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://cfe9b30508b44e40908da83aee0743e9@o389650.ingest.sentry.io/5556314",
    integrations: [new Sentry.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container!);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
